$(document).ready(function() {
    $('.giftVar input.sr-only').on('click', function() {

        // Find the associated swatchVar and giftVarPrice elements based on index
        const index = $('.giftVar input.sr-only').index(this);
        const selectedSwatchVar = $('.giftVar .mw_swatch_varaint').eq(index);
        const selectedGiftVarPrice = $('.giftVarPrice').eq(index);
    
        // Check if 'selected-field' class is present in swatchVar
        if ($(this).prop('checked')) {
        // Get the swatch_var_id attribute value
        const swatchVarId = selectedSwatchVar.attr('swatch_var_id');
    
        // Check if swatch_var_id is present in data-varComparePrice attribute of giftVarPrice
        const varComparePrice = selectedGiftVarPrice.attr('data-varComparePrice');
    
        if (varComparePrice && varComparePrice.includes(swatchVarId)) {
            // Get another attribute from giftVarPrice, for example, 'data-anotherAttribute'
            const anotherAttribute = selectedGiftVarPrice.attr('data-varPrice');
    
            // Place the values in specific places using text()
            const SalePriceContainer = selectedGiftVarPrice.closest('.product-info');
            const SalePrice = SalePriceContainer.find('.product-info__price sale-price');
            const ComparePrice = SalePriceContainer.find('.product-info__price compare-at-price');

            // console.log('SalePriceContainer:', SalePriceContainer);
            // console.log('SalePrice:', SalePrice, 'Length:', SalePrice.length);
            // console.log('ComparePrice:', ComparePrice, 'Length:', ComparePrice.length);
    
            SalePrice.html(anotherAttribute);
            ComparePrice.html(varComparePrice);

            // console.log(SalePrice);
            // console.log(ComparePrice);
            // console.log('**************');
        }
        }
    });




        const sofaDropdown = document.getElementById('sofa-dropdown');
        if(sofaDropdown){
            
            document.body.addEventListener('click', (elm)=>{

                if(event.target === sofaDropdown || sofaDropdown.contains(event.target)){
                    // sofaDropdown.addEventListener('click', (e)=>{
                        // let parentElm = e.target.closest('.custom_dropdown');
                        let parentElm = sofaDropdown.closest('.custom_dropdown');
            
                        if( parentElm.classList.contains('sofa-dropdown-selected')){
                            parentElm.classList.remove('sofa-dropdown-selected');
                        }else{
                            parentElm.classList.add('sofa-dropdown-selected');
                        }
                    // })
                }else{
                    let parentElm = sofaDropdown.closest('.custom_dropdown');
                    parentElm.classList.remove('sofa-dropdown-selected');
                }
            })

        }

});